exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#top{position:fixed;top:0;left:0;width:100%;z-index:200}#top .admin,#top .el-menu-item{float:right}#top span{color:#c0ccda;line-height:60px;padding-left:24px}#top .is-active a{color:#20a0ff}#top .el-dropdown{float:right;margin-right:20px;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-d6c4814a!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/Top.vue
// module id = 633
// module chunks = 0